import { useContext } from "react";
import PartnerApplicationStatusReview from "./review";
import PartnerApplicationStatusApproved from "./approved";
import PartnerApplicationStatusNotApproved from "./not-approved";
import PartnerEnrollmentFormContext from "../enrollment-form-context";

function PartnerApplicationStatus({ progressPercent = 0 }) {

  const { applicationStatus, s3Bucket } = useContext(PartnerEnrollmentFormContext);

  if (applicationStatus === 'Rejected') {
    return <PartnerApplicationStatusNotApproved />
  }

  if (applicationStatus === 'Pending' || !s3Bucket) {
    return <PartnerApplicationStatusReview progressPercent={progressPercent} />
  }

  if (applicationStatus === 'Approved') {
    return <PartnerApplicationStatusApproved progressPercent={progressPercent} />
  }

  return null
}

export default PartnerApplicationStatus;